import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import getTokenParts from 'forms-embed-utils-lib/share/getTokenParts';
const getShareLink = (formId, {
  version = 1,
  useSubdomain = false
} = {}) => {
  const {
    encodedPortalId,
    encodedFormId,
    versionSymbol,
    legacyPrefix
  } = getTokenParts({
    formId,
    portalId: `${PortalIdParser.get()}`,
    version
  });
  if (useSubdomain) {
    return `${getFullUrl(`${encodedPortalId}.share`, {
      domainOverride: 'hsforms',
      tldOverride: 'com'
    })}/${legacyPrefix}${versionSymbol}${encodedFormId}`;
  }
  return `${getFullUrl('share', {
    domainOverride: 'hsforms',
    tldOverride: 'com'
  })}/${legacyPrefix}${versionSymbol}${encodedFormId}${encodedPortalId}`;
};
export default getShareLink;